import { render, staticRenderFns } from "./ReportProject.vue?vue&type=template&id=f0f5cdae&scoped=true"
import script from "./ReportProject.vue?vue&type=script&lang=js"
export * from "./ReportProject.vue?vue&type=script&lang=js"
import style0 from "./ReportProject.vue?vue&type=style&index=0&id=f0f5cdae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f5cdae",
  null
  
)

export default component.exports